import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../App';
import LanguageToggle from '../components/LanguageToggle';
import { useLanguage } from '../LanguageContext';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { t } = useLanguage();
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-lang-toggle">
          <LanguageToggle />
        </div>
        <div className="auth-logo">
          <h1>{t('common.appName')}</h1>
          <p>{t('forgotPassword.subtitle')}</p>
        </div>

        {submitted ? (
          <div className="alert alert-success">
            {t('forgotPassword.successMessage')}
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            {error && (
              <div className="alert alert-error">
                {error}
              </div>
            )}

            <div className="form-field">
              <label htmlFor="email">{t('forgotPassword.emailLabel')}</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('forgotPassword.emailPlaceholder')}
                required
                autoComplete="email"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="loading-spinner" style={{ width: 20, height: 20 }}></span>
                  {t('forgotPassword.submitting')}
                </>
              ) : (
                t('forgotPassword.submit')
              )}
            </button>
          </form>
        )}

        <div className="auth-links">
          <p>
            <Link to="/login">{t('forgotPassword.backToLogin')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
